import React, { Component } from 'react';
import Inline from '../Inline';
import FontAwesome from 'react-fontawesome';
import FontAwesomeIcon from './FontAwesomeIcon';
import { style } from 'typestyle';

class OptionButtons extends Component {
    state = {
        items: this.props.items ?? [],
        selectedIndex: this.props.selectedIndex ?? (this.props.items ?? []).findIndex(x => x.selected)
    }

    onItemClick = (item, ix) => {
        this.setState({ selectedIndex: ix }, () => this.props.onSelectionChanged?.(item, ix));
    }

    render() {
        return (
            <Inline spacing='0px' style={{ margin: '0', cursor: 'pointer', fontSize: '0.9rem', ...this.props.style }}>
                {
                    this.state.items.map((item, ix) => (
                        <Inline spacing='0.5rem' key={'item_' + ix} rtl
                            onClick={() => this.onItemClick(item, ix)}
                            style={{
                                borderRadius: ix === 0 ? '0 1rem 1rem 0' : ix === this.state.items.length - 1 ? '1rem 0 0 1rem' : '0',
                                border: '1px solid #ccccccee',
                                borderLeft: ix < this.state.items.length - 1 ? 'none' : '1px solid #ccccccee',
                                padding: '0.5rem 1rem',
                                background: this.state.selectedIndex === ix ? 'steelblue' : 'transparent',
                                color: this.state.selectedIndex === ix ? 'whitesmoke' : 'darkslateblue',
                                width: this.props.itemWidth ?? 'notset',
                                justifyContent: 'center'
                            }}

                            className={style({ '&:hover': { backgroundColor: 'red' } })}
                        >
                            {item.icon?.length > 0 && <FontAwesomeIcon icon={item.icon} />}
                            <div>
                                {item.text ?? item}
                            </div>
                        </Inline>
                    ))
                }
            </Inline>
        );
    }
}

export default OptionButtons;